import React, { useEffect, useState } from 'react'
import { API, BACKEND_HOST } from '../../api'
import { imageUpload } from '../../utils/handleImage'
import { getAccessToken } from '../../api/auth'
import { Button } from '@/Components/ui';

function ImagesUploader({ groupKey, userId, onUploaded, endpoint = "inquiry/images" }) {

    const [previewImages, setPreviewImages] = useState([])
    const [imageUploadProgress, setImageUploadProgress] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchImages(groupKey)
    }, [groupKey])

    const fetchImages = (groupKey, updated = false) => {
        API.get(
            `${BACKEND_HOST}/${endpoint}/?group_key=${groupKey}`
        )
            .then((res) => {
                setPreviewImages(res.data)
                if (updated) onUploaded(res.data)
            })
            .catch((e) => { console.log(e); })
    }

    const handleUpload = (e) => {
        const file = e.currentTarget.files[0]
        const accessToken = getAccessToken();
        // console.log("handleUpload", accessToken)
        console.log("handleUpload", file)

        setLoading(true)
        imageUpload({
            accessToken,
            url: `${BACKEND_HOST}/${endpoint}/`,
            groupKey, userId,
            file, name: file.name,
            onUploadProgress: (percentCompleted) => {
                setImageUploadProgress(percentCompleted)
            }
        }).then(result => {
            console.log(result)
            fetchImages(groupKey, true)
            setLoading(false)

            e.currentTarget.value = ""
        }).catch(error => {
            console.warn(error)
        })
    }

    const handleDelete = (imageId) => {
        API.delete(
            `${BACKEND_HOST}/${endpoint}/?id=${imageId}`
        ).then(result => {
            fetchImages(groupKey, true)
            console.log(result)
        }).catch(error => {
            console.warn(error)
        })
    }

    return (
        <React.Fragment>
            <div className="flex flex-wrap justify-center -mx-3">
                <div className="w-full px-3 mb-3">
                    <div className='d-flex flex-direction-row gap-3 flex-wrap'>
                        {previewImages ? previewImages.map(_image => (<div key={_image.id}>
                            <div><img src={`${_image.image}`} style={{ maxWidth: 100 }} /></div>
                            <div style={{ position: "absolute", bottom: 5, paddingLeft: 5 }}><Button  onClick={() => handleDelete(_image.id)} size="sm">삭제</Button></div>
                        </div>)) : null}
                    </div>
                </div>
                <div className="w-full px-3">
                    {loading ? imageUploadProgress : null}
                </div>
            </div>
            <div className="flex flex-wrap justify-center -mx-3">
                <div className="w-full px-3">
                    <span>이미지 업로더: </span>
                    <input type="file" accept="image/*" onChange={(e) => {
                        handleUpload(e)
                    }} />
                    <div style={{ color: "GrayText" }}>한번에 한장씩, 여러 장의 이미지를 업로드 할 수 있습니다.</div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ImagesUploader
